import React, { Component } from 'react';
import { RichText } from 'prismic-reactjs';
import './style.css';
import { Watch } from 'scrollmonitor-react';
import AddAnimationClass from '../../shared/helpers/addAnimationClass';

export default Watch(class Landing extends Component {

    firstTime = true;

    componentWillUpdate(nextProps) {
        if (typeof nextProps.content !== 'undefined' && this.firstTime) {
            this.props.startWatcher();
            this.firstTime = false;
        }
    }

    componentDidUpdate() {
        if (this._container.classList.contains("loading") && !this.firstTime) {
            this._container.classList.remove("loading");
        }
    }


    componentDidMount() {
        this.props.startWatcher();
    }

    render() {
        let header;
        if (typeof this.props.content !== 'undefined') {
            header = (
                <span>
                    {RichText.render(this.props.content.data.content)}
                </span>
            )
        }
        if (this.props.isInViewport) {
            AddAnimationClass(this._container, 200)
            this.props.stopWatcher();
        }
        return (
            <section className="site-section landing loading" ref={(el) => { this._container = el; }}>
                <span className="decoration-line to-animate"></span>
                <div className="wrapper">
                    <svg className="line-top to-animate" width="100%" height="100%" viewBox="0 0 602 170" >
                        <polyline id="Path-2" fill="none" strokeWidth="1px" vectorEffect="non-scaling-stroke" stroke="#0080C8" points="1 0 1 124 601 124 601 170" ></polyline>
                    </svg>
                    <div className="landing-intro to-animate">
                        <svg className="square to-animate" width="100%" height="100%" viewBox="0 0 591 401" preserveAspectRatio="none" >
                            <polyline fill="none" strokeWidth="1px" vectorEffect="non-scaling-stroke" stroke="#0080C8" points="295 400 1 400 1 1 590 1 590 400 295 400" ></polyline>
                        </svg>
                        {header}
                        <a href="#contact" className="cta-btn to-animate">
                            Contact
				    </a>
                    </div>
                    <span className="line-container">
                        <svg className="line-bottom to-animate" width="100%" height="100%" viewBox="0 0 177 171">
                            <polyline fill="none" strokeWidth="1px" vectorEffect="non-scaling-stroke" stroke="#0080C8" points="176 0 176 46 0 170"></polyline>
                        </svg>
                    </span>
                </div>
                <span id="about" className="angle__push-content"><span className="content"></span></span>
            </section>
        );
    }
});


// WEBPACK FOOTER //
// ./src/components/landing/index.js